<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="text-right">
        <v-btn color="primary" icon dark class="mr-4" @click="refresh">
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <OrganizationLocationsTab
      :organizationLocations="organizationLocations"
      :locations="locations"
      :nestedLocations="nestedLocations"
      v-on:importLocation="importLocation"
      v-on:removeLocation="deleteLocation"
    />
    <v-snackbar v-model="snackbar" top>
      {{ errorMessage }}
      <v-btn color="red" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import mixin from "@/mixins";
import OrganizationLocationsTab from "@/components/Admin/Organizations/OrganizationLocationsTab";

export default {
  mixins: [mixin],
  components: {
    OrganizationLocationsTab
  },
  data() {
    return {
      organizationUuid: this.$route.params.organizationId,
      errorMessage: "",
      snackbar: false,
      organizationLocations: [],
      locations: [],
      nestedLocations: []
    };
  },
  methods: {
    ...mapActions("organizations", {
      fetchAllOrganizationLocations: "fetchAllLocations",
      addLocation: "addLocation",
      removeLocation: "removeLocation"
    }),
    ...mapActions("locations", { fetchAllLocations: "fetchAll" }),
    refresh() {
      this.fetchAllLocations({ nested: true })
        .then(locations => {
          this.nestedLocations = locations;
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
      this.fetchAllLocations({ nested: false })
        .then(locations => {
          this.locations = locations;
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
      this.fetchAllOrganizationLocations({
        organizationUuid: this.organizationUuid
      })
        .then(locations => {
          this.organizationLocations = locations;
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    },
    importLocation(locationUuid) {
      this.addLocation({
        organizationUuid: this.organizationUuid,
        locationUuid: locationUuid
      })
        .then(() => {
          this.refresh();
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    },
    deleteLocation(locationUuid) {
      this.removeLocation({
        organizationUuid: this.organizationUuid,
        locationUuid: locationUuid
      })
        .then(() => {
          this.refresh();
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    }
  },
  created() {
    this.refresh();
  }
};
</script>

<style>
</style>